import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import SubmissionViewModel from '../../../../SubmissionViewModel'
import Summary from '../../Summary'
import Submission from '../../Submission'
import styles from './FormSubmission.sass'

interface FormSubmissionProps {
  vm: SubmissionViewModel
}

/**
 * The FormSubmission
 */
export default observer(function FormSubmission({ vm }: FormSubmissionProps) {
  return (
    <div className={cx(styles.root)}>
      <Block>
        <Summary vm={vm} />
      </Block>
      <Block>
        <Submission vm={vm} />
      </Block>
    </div>
  )
})

interface BlockProps {
  children?: React.ReactNode
}

/**
 " Block
 */
export function Block({ children }: BlockProps) {
  return <div className={styles.block}>{children}</div>
}
